import React, { useState } from 'react';
import {
  ListItem, ListItemIcon, ListItemText, Box,
  Typography, Chip, Avatar, Divider, Tooltip, IconButton, CircularProgress
} from '@mui/material';
import {
  PaymentsOutlined,
  AccountBalanceOutlined,
  QrCodeScannerOutlined,
  AccessTimeOutlined,
  CheckCircleOutline,
  CheckOutlined
} from '@mui/icons-material';

const getMethodIcon = (method) => {
  switch (method) {
    case 'cash': return <PaymentsOutlined color="success" />;
    case 'bank': return <AccountBalanceOutlined color="primary" />;
    case 'iris': return <QrCodeScannerOutlined color="info" />;
    default: return <PaymentsOutlined />;
  }
};

const getMethodLabel = (method) => {
  switch (method) {
    case 'cash': return "Μετρητά";
    case 'bank': return "Τραπεζική Κατάθεση";
    case 'iris': return "IRIS";
    default: return "Άγνωστο";
  }
};


export default function DepositRow({ deposit, devSku, isLast, isAdmin, onSuccess }) {

  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user/device/${deposit.deviceId}/deposit/${deposit._id}`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({accept: true})
        }
      );

      if (response.ok) {
        const data = await response.json();
        onSuccess(data.balance);
      } else {

      }
    } catch (error) {
      console.error("Accept error:", error);
    } finally {
      setLoading(false);
    }
  };

  const getPaymentInstructions = () => {
    if (deposit.accepted) return null;
    let instructions = null;
    switch (deposit.method) {
      case 'bank':
        instructions = (
          <>
            <Typography variant="caption" display="block" sx={{ fontWeight: 'bold'}}>
              Κάντε κατάθεση στον παρακάτω λογαριασμό με αιτιολογία <b>DEV {devSku}</b>
            </Typography>
            <Typography variant="caption" display="block"><span style={{color:"rgba(0,0,0,0.7)"}}>Τράπεζα:</span> Πειραιώς</Typography>
            <Typography variant="caption" display="block"><span style={{color:"rgba(0,0,0,0.7)"}}>Δικαιούχος:</span> Θεμιστοκλής Τριανταφυλλίδης</Typography>
            <Typography variant="caption" display="block"><span style={{color:"rgba(0,0,0,0.7)"}}>IBAN:</span> GR12 3456 7890 1234 5678 9012</Typography>
            <Typography variant="caption" display="block"><span style={{color:"rgba(0,0,0,0.7)"}}>Αιτιολογία:</span> DEV {devSku}</Typography>
          </>
        );
        break;
      case 'iris':
        instructions = (
          <>
            <Typography variant="caption" display="block" sx={{ fontWeight: 'bold' }}>
                Στείλτε τα χρήματα στον παρακάτω αριθμό με αιτιολογία <b>DEV {devSku}</b>
            </Typography>
            <Typography variant="caption" display="block"><span style={{color:"rgba(0,0,0,0.7)"}}>Τηλέφωνο:</span> 123456789</Typography>
            <Typography variant="caption" display="block"><span style={{color:"rgba(0,0,0,0.7)"}}>Αιτιολογία:</span> DEV {devSku}</Typography>
          </>
        );
        break;
      case 'cash':
        instructions = (
          <Typography variant="caption" display="block" sx={{ fontWeight: 'bold' }}>
            Δώστε τα χρήματα στο κατάστημα της Ροδόπολης
          </Typography>
        );
        break;
      default:
        instructions = null;
    }

    if (instructions) {
      return (
          <Box sx={{ mb: 2, p: 1, bgcolor: 'primary.light' }}>
            {instructions}
          </Box>
      );
    }
    return null;
  };

  return (
    <>
      <ListItem
        sx={{ px: 0, py: 2 }}
        secondaryAction={
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              +{deposit.amount} €
            </Typography>
            <Chip
              size="small"
              label={deposit.accepted ? "Ολοκληρώθηκε" : "Εκκρεμεί"}
              color={deposit.accepted ? "success" : "warning"}
              variant="outlined"
              icon={deposit.accepted ? <CheckCircleOutline /> : <AccessTimeOutlined />}
              sx={{ mt: 0.5, fontSize: '0.7rem' }}
            />
            {isAdmin && !deposit.accepted && (
              <Tooltip title="Αποδοχή Πληρωμής">
                <IconButton
                  size="small"
                  color="success"
                  onClick={handleAccept}
                  disabled={loading}
                  sx={{
                    mt: 0.5,
                    ml: 0.5,
                    width: 24,
                    height: 24,
                    p: 0,
                    bgcolor: 'success.main',
                    color: 'white',
                    '&:hover': {
                      bgcolor: 'success.dark',
                      color: 'white'
                    }
                  }}
                >
                  {loading ? (
                    <CircularProgress size={14} color="inherit" />
                  ) : (
                    <CheckOutlined sx={{ fontSize: 16 }} />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </Box>
        }
      >
        <ListItemIcon>
          <Avatar sx={{ bgcolor: 'grey.100' }}>
            {getMethodIcon(deposit.method)}
          </Avatar>
        </ListItemIcon>
        <ListItemText
          sx={{ display: { xs: 'none', sm: 'block' } }}
          primary={getMethodLabel(deposit.method)}
          secondary={new Date(deposit.createdAt).toLocaleString('el-GR')}
        />
      </ListItem>
      {getPaymentInstructions()}
      {!isLast && <Divider component="li" />}
    </>
  );
}
